import { OOS_QTY_THRESHOLD } from 'utils/constants'

export const availableForSale = ({ variant, province }) => {
  if (!variant) return true
  if (!variant.availableProvinces.includes(province)) return false
  if (!variant.quantities) return true
  const qtyForProvince = variant.quantities[province]
  if (typeof qtyForProvince === 'undefined') return true
  if (qtyForProvince < OOS_QTY_THRESHOLD) return false
  return true
}
